import React, { useState } from "react";
import Helmet from "react-helmet";
import { Link } from "gatsby";

export default function Login() {
  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [err, setErr] = useState("");

  async function onLogin(e) {
    e.preventDefault();

    if (!email) {
      setErr("Email required");
      return;
    }

    if (!pass) {
      setErr("Password required");
      return;
    }

    const url = "https://apmgui.dripstat.com/rest/login";
    const requestInit = {
      method: "POST",
      mode: "cors",
      redirect: "follow",
      credentials: "include",
      cache: "no-cache",
      body: new URLSearchParams(`username=${encodeURIComponent(email)}&password=${encodeURIComponent(pass)}&rememberMe=true`),
    };
    const r = await fetch(new Request(url, requestInit));
    const responseMsg = await r.text();
    if (r.status === 200) {
      let dashboard = "https://dashboard.dripstat.com";

      if (responseMsg === "isMasterUser") {
        dashboard += "?isMasterUser=true";
      }
      window.location.href = dashboard;
    } else if (r.status === 401) {
      setErr(responseMsg);
    }
  }

  return (
    <>
      <Helmet lang="en" title="Login">
        <meta name="viewport" content="width=device-width" />
      </Helmet>
      <div id="authPage">
        <div className="container">
          <div className="columns is-desktop is-vcentered auth-wrapper">
            <div className="column has-text-centered">
              <Link to="/">
                <img src="/img/dripstat-logo-black.png" style={{ height: "58px" }} alt="" />
              </Link>
            </div>

            <div className="column">
              <form id="loginform" acceptCharset="UTF-8" name="loginform">
                <p>
                  <label htmlFor="login-name">Email</label>
                  <input className="form-control" type="text" name="username" required="required" id="login-name" value={email} onChange={e => setEmail(e.target.value)} />
                </p>
                <p>
                  <label htmlFor="login-password">Password</label>
                  <input className="form-control" type="password" name="password" required="required" id="login-password" value={pass} onChange={e => setPass(e.target.value)} />
                </p>

                {err && (
                  <div className="alert alert-danger" id="loginError">
                    {err}
                  </div>
                )}
                <button className="btn lilac-btn btn-fluid btn-medium" id="loginBtn" type="submit" onClick={onLogin}>
                  Login
                </button>
                <div className="form-forgot">
                  <Link to="/recover-password/">Forgot Password?</Link>
                </div>
              </form>
            </div>
          </div>
          <div className="columns">
            <div className="column">
              <div className="form-signup">
                Don't have an account?&nbsp;<Link to="/signup">Signup</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
